import axios from "@/axios";

const getPeriodTAGByRut = async (patent, rut) => {
  const periodResponse = await axios.get(`/PeriodosTAGByPatente?patente=${patent}&rut=${rut}`)
  const periods = periodResponse.data.map(periodResponse => periodResponse);
  return periods;
}

export default {
  getPeriodTAGByRut,
};
